module.exports = __webpack_public_path__ + "assets/folder-organization.be8a4d2e.svg";